const LargeProductCard = ({
  productImage,
  productName,
  vegetables,
  seedTapes,
  totalPlants,
  plantsCount,
  plantCountExtras,
  plantsIcon,
  description,
  vegetableImages,
  price,
  onProductClick,
  extras,
  detailsFloatRight = false,
}) => {
  return (
    <div className="w-full flex flex-row rounded-full px-2 py-2 bg-[radial-gradient(circle_at_0%_0%,#759b8b,#b2cc6c,#81bc00)] relative min-h-[200px]">
      {/* Product Photo */}
      <div className="flex justify-center items-center bg-white rounded-full w-52 h-52">
        <img
          src={productImage}
          alt={productName}
          className="w-40 h-40 object-contain"
        />
      </div>

      {/* Product Name Banner */}
      <div className="absolute left-32 -top-5 w-96 rounded-full px-4 py-2 bg-[linear-gradient(90deg,#006639,#82bd02,#779b8b)]">
        <h4 className="text-white text-2xl font-bold">{productName}</h4>
      </div>

      {/* Product Details */}
      <div className="flex flex-col mt-8">
        <div className="flex flex-col justify-between px-4 text-black w-[480px] 2xl:w-[550px]">
          <h5 className="text-lg font-bold uppercase">{vegetables}</h5>
        </div>

        {/* Product Details 2*/}
        <div
          className={`flex ${
            detailsFloatRight ? "flex-row gap-4" : "flex-col"
          } justify-between px-4 w-full max-w-screen-sm`}
        >
          <div>
            <li className="text-sm font-semibold uppercase">{seedTapes}</li>
            <li className="text-sm font-semibold uppercase">{totalPlants}</li>
            {extras && (
              <li className="text-sm font-semibold uppercase">{extras}</li>
            )}
          </div>
          <div className="flex flex-col">
            <div className="flex flex-row gap-4 text-white">
              <div
                className={`flex ${
                  detailsFloatRight ? "flex-row gap-2" : "flex-col"
                }`}
              >
                <p
                  className="text-xl italic"
                  style={{
                    fontFamily:
                      "'Kalam', 'Caveat', 'Dancing Script', 'Brush Script MT', cursive",
                  }}
                >
                  Plants:
                </p>
                <p className="text-lg font-bold text-black">{plantsCount}</p>
              </div>
              {plantsIcon && (
                <div className="flex flex-col justify-center">
                  <img src={plantsIcon} alt="plants icon" className="h-10" />
                </div>
              )}
            </div>
            {!plantCountExtras && (
              <div className="flex flex-row mt-5">
                <p
                  className={`text-lg font-extrabold uppercase text-white text-nowrap`}
                >
                  {description}
                </p>
              </div>
            )}
            {plantCountExtras && (
              <>
                <div className="flex flex-col">
                  {plantCountExtras.map((text, index) => (
                    <li
                      className="text-xs text-black font-semibold uppercase"
                      key={index}
                    >
                      {text}
                    </li>
                  ))}
                </div>
              </>
            )}
          </div>
          {plantCountExtras && (
            <div className="flex flex-row">
              <p
                className={`text-lg font-extrabold uppercase text-white text-nowrap over absolute bottom-5`}
              >
                {description}
              </p>
            </div>
          )}
        </div>
      </div>

      {/* Product Photos */}
      <div className="flex flex-row justify-end absolute right-64 2xl:right-72 top-5 w-80 2xl:w-96">
        {vegetableImages.map((image, index) => (
          <img
            key={index}
            src={image.src}
            alt={image.alt}
            className="h-full w-20 2xl:w-24 object-cover relative"
            style={{
              marginLeft: index > 0 ? "-45px" : "0",
              zIndex: vegetableImages.length - index,
            }}
          />
        ))}
      </div>

      {/* Pricing section */}
      <div className="flex flex-col ml-auto w-1/5 items-center justify-center pr-4 gap-4">
        <h5 className="text-4xl font-bold text-white">R{price}</h5>
        <button
          className="bg-[#bad36c] text-white font-semibold py-2 px-4 hover:bg-[#a8c560] transition-colors duration-200"
          onClick={onProductClick}
        >
          Go to Product
        </button>
      </div>
    </div>
  );
};

export default LargeProductCard;
